var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "md-menu",
    { attrs: { "md-align-trigger": "", "md-direction": "bottom-end" } },
    [
      _c(
        "md-button",
        {
          staticClass: "md-icon-button",
          attrs: { "md-menu-trigger": "", disabled: _vm.disabled }
        },
        [_vm._t("button")],
        2
      ),
      _vm._v(" "),
      _c("md-menu-content", [_vm._t("items")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }